import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { FaChevronDown } from "react-icons/fa";
import BreadCrumbComp from "../../../components/breadCrumb";
import { Box, Grid, Tab, Tabs } from "@mui/material";
import { icons } from "../../../constants";
import LaddaButton from "../../../components/buttons/laddaButton";
import {
  callActionApiAsync,
  callApiAsync,
  getCallSelectsBiomedicalEquipment,
  getBiomedicalEquipmentModelSummary,
  getBiomedicalEquipmentModels,
  getSelectsBiomedical,
  patchReassignBiomedicalEquipmentModelBrand
} from "../../../services/apiService";
import AddUbicationModal from "../modals/addUbicationModal";
import AddModelModal from "./AddModelModal";
import DeleteLocationModal from "./DeleteLocationModal";
import DeleteModelModal from "./DeleteModelModal";
import EditLocationModal from "./EditLocationModal";
import EditModelModal from "./EditModelModal";
import ModelInspectionProtocolTab from "./ModelInspectionProtocolTab";
import ModelAdverseEventsTab from "./ModelAdverseEventsTab";
import ModelAccessoriesTab from "./ModelAccessoriesTab";
import ModelResumeTab from "./ModelResumeTab";
import ModelTechnicalFeaturesTab from "./ModelTechnicalFeaturesTab";
import CatalogItemModal from "./CatalogItemModal";
import DeleteCatalogItemModal from "./DeleteCatalogItemModal";
import ToastNotification from "../../../components/toastNotification";
import { getCookie } from "../../../utils/getCookie";
import { useSelector } from "react-redux";
import { hasAnyRoleUtil } from "../../../utils/AuthorizedUtils/360Report";
import { BIOMEDICAL_MODULE_ADMIN } from "../../../constants/biomedicalRoles";
import "./adminCatalog.css";

/**
 * Catálogos activos en esta entrega: ubicación física y marca.
 * Los demás quedan comentados para reactivarlos cuando sean aprobados.
 */
const CATALOG_DEFS = [
  {
    id: "ubication",
    dataKey: "ubication",
    shortLabel: "Ubicación física",
    actionLabels: {
      create: "Crear",
      edit: "Editar",
      delete: "Eliminar"
    },
    description:
      "Lugares donde puede instalarse o registrarse un equipo (almacén, servicio, etc.). " +
      "Se usa en el formulario de equipo como «ubicación actual». " +
      "Si una ubicación tiene equipos asignados, al eliminarla deberá migrarlos a otra."
  },
  {
    id: "brand",
    dataKey: "brands",
    shortLabel: "Marcas",
    actionLabels: {
      create: "Crear",
      edit: "Editar",
      delete: "Eliminar"
    },
    description:
      "Catálogo de marcas usadas por los equipos y modelos biomédicos."
  },
  // {
  //   id: "model",
  //   dataKey: "models",
  //   shortLabel: "Modelos",
  //   actionLabels: {
  //     create: "Crear",
  //     edit: "Editar",
  //     delete: "Eliminar"
  //   },
  //   description:
  //     "Catálogo de modelos biomédicos asociados a una marca. " +
  //     "Permite administrar el modelo por ID y, desde una pestaña aparte, cambiar la marca del modelo seleccionado."
  // },
  // {
  //   id: "importer",
  //   dataKey: "importers",
  //   shortLabel: "Importador",
  //   actionLabels: {
  //     create: "Crear",
  //     edit: "Editar",
  //     delete: "Eliminar"
  //   },
  //   description:
  //     "Catálogo de importadores usados en el registro de equipos biomédicos."
  // },
  // {
  //   id: "producer",
  //   dataKey: "producers",
  //   shortLabel: "Fabricante",
  //   actionLabels: {
  //     create: "Crear",
  //     edit: "Editar",
  //     delete: "Eliminar"
  //   },
  //   description:
  //     "Catálogo de fabricantes usados en el registro de equipos biomédicos."
  // },
  // {
  //   id: "riskClassification",
  //   dataKey: "riskClassifications",
  //   shortLabel: "Clasificación por riesgo",
  //   actionLabels: {
  //     create: "Crear",
  //     edit: "Editar",
  //     delete: "Eliminar"
  //   },
  //   description:
  //     "Catálogo de clasificaciones de riesgo para equipos biomédicos."
  // },
  // {
  //   id: "state",
  //   dataKey: "state",
  //   shortLabel: "Modalidad - Estado",
  //   actionLabels: {
  //     create: "Crear",
  //     edit: "Editar",
  //     delete: "Eliminar"
  //   },
  //   description:
  //     "Catálogo de estados usados en el campo Estado del formulario de inventario biomédico."
  // },
  // {
  //   id: "adverseEventType",
  //   dataKey: "adverseEventTypes",
  //   shortLabel: "Tipo de Suceso",
  //   actionLabels: {
  //     create: "Crear",
  //     edit: "Editar",
  //     delete: "Eliminar"
  //   },
  //   description:
  //     "Catálogo de tipos de suceso disponibles para los eventos adversos del inventario biomédico."
  // },
  // {
  //   id: "adverseEventGravity",
  //   dataKey: "adverseEventGravities",
  //   shortLabel: "Gravedad",
  //   actionLabels: {
  //     create: "Crear",
  //     edit: "Editar",
  //     delete: "Eliminar"
  //   },
  //   description:
  //     "Catálogo de niveles de gravedad usados en los eventos adversos del inventario biomédico."
  // },
  // {
  //   id: "adverseEventsTemplate",
  //   dataKey: "models",
  //   shortLabel: "Eventos adversos presentados",
  //   actionLabels: {
  //     create: "Crear",
  //     edit: "Editar",
  //     delete: "Eliminar"
  //   },
  //   description:
  //     "Administra la plantilla de eventos adversos por marca y modelo. Al abrir un equipo existente se completarán solo las combinaciones faltantes."
  // }
];

const SECTION_GROUPS = [
  {
    parentLabel: "Hoja de vida",
    children: [
      {
        id: "lifeSheet",
        shortLabel: "Hoja de vida por modelo",
        description:
          "Administra la plantilla base de hoja de vida por marca y modelo para autocompletar y sincronizar los equipos biomédicos."
      },
      // {
      //   id: "lifeSheetFeatures",
      //   shortLabel: "Características técnicas del modelo",
      //   description:
      //     "Administra las características técnicas por marca y modelo y resincroniza los equipos biomédicos relacionados."
      // },
      // {
      //   id: "lifeSheetAccessories",
      //   shortLabel: "Accesorios del modelo",
      //   description:
      //     "Administra los accesorios por marca y modelo. En el formulario biomédico solo se muestra el nombre del accesorio, pero la hoja de vida conserva número de parte y cantidad."
      // }
    ]
  },
  {
    parentLabel: "Actas de inspección",
    children: [
      {
        id: "inspection",
        shortLabel: "Protocolo editable",
        description:
          "Administra las actividades del protocolo de inspección por marca y modelo sin afectar los protocolos ya creados por equipo."
      }
    ]
  }
];

const SECTION_DEFS = SECTION_GROUPS.reduce(
  (acc, group) => [...acc, ...(group.children || []).map((child) => ({ ...child, parentLabel: group.parentLabel }))],
  []
);

const normalizeRows = (list) =>
  (list || []).map((r) => {
    const num = r.value != null && r.value !== "" ? Number(r.value) : NaN;
    return {
      ...r,
      value: Number.isFinite(num) ? num : r.value,
      name: r.name
    };
  });

const SIMPLE_CATALOG_META = {
  brand: {
    catalogType: "brand",
    labelSingular: "marca",
    capitalizeLabel: "Marca",
    labelArticle: "la marca",
    fieldLabel: "Nombre de la marca",
    createTitle: "Nueva marca",
    supportsMigration: false,
    relatedCountLabel: "modelo(s)",
    relatedTableTitle: "Modelos que usan esta marca",
    relatedEmptyMessage: "Sin modelos vinculados",
    deleteBlockedUsageText:
      "Debe dejar de usarse en equipos biomédicos y modelos antes de eliminarla."
  },
  importer: {
    catalogType: "importer",
    labelSingular: "importador",
    capitalizeLabel: "Importador",
    labelArticle: "el importador",
    fieldLabel: "Nombre del importador",
    createTitle: "Nuevo importador"
  },
  producer: {
    catalogType: "producer",
    labelSingular: "fabricante",
    capitalizeLabel: "Fabricante",
    labelArticle: "el fabricante",
    fieldLabel: "Nombre del fabricante",
    createTitle: "Nuevo fabricante"
  },
  riskClassification: {
    catalogType: "riskClassification",
    labelSingular: "clasificación por riesgo",
    capitalizeLabel: "Clasificación por riesgo",
    labelArticle: "la clasificación por riesgo",
    fieldLabel: "Nombre de la clasificación por riesgo",
    createTitle: "Nueva clasificación por riesgo"
  },
  state: {
    catalogType: "state",
    labelSingular: "estado",
    capitalizeLabel: "Estado",
    labelArticle: "el estado",
    fieldLabel: "Nombre del estado",
    createTitle: "Nuevo estado"
  },
  adverseEventType: {
    catalogType: "adverseEventType",
    labelSingular: "tipo de suceso",
    capitalizeLabel: "Tipo de suceso",
    labelArticle: "el tipo de suceso",
    fieldLabel: "Nombre del tipo de suceso",
    createTitle: "Nuevo tipo de suceso",
    supportsMigration: false,
    relatedCountLabel: "plantilla(s) por modelo",
    relatedTableTitle: "Plantillas por modelo que usan este valor",
    relatedEmptyMessage: "Sin plantillas vinculadas",
    deleteBlockedUsageText:
      "Debe dejar de usarse en eventos de equipos y plantillas por modelo antes de eliminarlo."
  },
  adverseEventGravity: {
    catalogType: "adverseEventGravity",
    labelSingular: "gravedad",
    capitalizeLabel: "Gravedad",
    labelArticle: "la gravedad",
    fieldLabel: "Nombre de la gravedad",
    createTitle: "Nueva gravedad",
    supportsMigration: false,
    relatedCountLabel: "plantilla(s) por modelo",
    relatedTableTitle: "Plantillas por modelo que usan este valor",
    relatedEmptyMessage: "Sin plantillas vinculadas",
    deleteBlockedUsageText:
      "Debe dejar de usarse en eventos de equipos y plantillas por modelo antes de eliminarla."
  }
};

const CatalogCrudToolbar = ({ labels, onCreate, onEdit, onDelete }) => (
  <div className="admin-catalog-actions">
    <LaddaButton variant="contained" onClick={onCreate}>
      <span className="HContainer align-center">
        <img className="btn-icon mr-10" src={icons.plusIcon} alt="" />
        {labels.create}
      </span>
    </LaddaButton>
    <LaddaButton variant="contained" onClick={onEdit} color="#000000" backgroundColor="#F4D658">
      <span className="HContainer align-center">
        <img className="btn-icon mr-10" src={icons.pencilBlack} alt="" />
        {labels.edit}
      </span>
    </LaddaButton>
    <LaddaButton variant="contained" onClick={onDelete} backgroundColor="#f43f5e">
      <span className="HContainer align-center">
        <img className="btn-icon mr-10" src={icons.trash} alt="" />
        {labels.delete}
      </span>
    </LaddaButton>
  </div>
);

const BiomedicalAdminPage = () => {
  const userData = useSelector((state) => state.userData.userData);
  const userSesion = getCookie("sesion");
  const adminUserId = userSesion?.id_usuario;

  const isCatalogAdmin = hasAnyRoleUtil(
    [BIOMEDICAL_MODULE_ADMIN],
    userData?.roleList
  );

  const [selectsData, setSelectsData] = useState({
    ubication: [],
    state: [],
    adverseEvents: [],
    adverseEventTypes: [],
    adverseEventGravities: [],
    brands: [],
    importers: [],
    producers: [],
    riskClassifications: []
  });
  const [activeSectionId, setActiveSectionId] = useState("inventory");
  const [activeCatalogId, setActiveCatalogId] = useState("ubication");
  const [selectedCatalogItemId, setSelectedCatalogItemId] = useState(null);
  const [selectedBrandId, setSelectedBrandId] = useState(null);
  const [navExpanded, setNavExpanded] = useState(true);
  const [modelRows, setModelRows] = useState([]);
  const [modelSummary, setModelSummary] = useState(null);
  const [modelTab, setModelTab] = useState("catalog");
  const [reassignNewBrandId, setReassignNewBrandId] = useState(null);
  const [reassignLoading, setReassignLoading] = useState(false);

  const [showToast, setShowToast] = useState(false);
  const [toastConfig, setToastConfig] = useState({
    severity: "warn",
    summary: "",
    detail: ""
  });

  const [openAddUbication, setOpenAddUbication] = useState(false);
  const [openEditUbication, setOpenEditUbication] = useState(false);
  const [openDeleteUbication, setOpenDeleteUbication] = useState(false);
  const [openAddModel, setOpenAddModel] = useState(false);
  const [openEditModel, setOpenEditModel] = useState(false);
  const [openDeleteModel, setOpenDeleteModel] = useState(false);
  const [catalogModalMode, setCatalogModalMode] = useState(null);
  const [openDeleteCatalogItem, setOpenDeleteCatalogItem] = useState(false);

  const pushToast = useCallback((severity, summary, detail) => {
    setToastConfig({ severity, summary, detail });
    setShowToast(true);
  }, []);

  const activeDef = useMemo(
    () => CATALOG_DEFS.find((d) => d.id === activeCatalogId) || CATALOG_DEFS[0],
    [activeCatalogId]
  );

  const activeSimpleCatalogMeta = useMemo(
    () => SIMPLE_CATALOG_META[activeCatalogId] || null,
    [activeCatalogId]
  );

  const isSimpleCatalog = !!activeSimpleCatalogMeta;

  const usesModelWorkspace = useMemo(
    () =>
      activeSectionId === "lifeSheet" ||
      activeSectionId === "lifeSheetFeatures" ||
      activeSectionId === "lifeSheetAccessories" ||
      activeSectionId === "inspection" ||
      activeCatalogId === "adverseEventsTemplate" ||
      activeCatalogId === "model",
    [activeCatalogId, activeSectionId]
  );

  const contentDescription = useMemo(() => {
    if (activeSectionId !== "inventory") {
      return SECTION_DEFS.find((item) => item.id === activeSectionId)?.description || "";
    }
    return activeDef.description;
  }, [activeDef.description, activeSectionId]);

  const brandRows = useMemo(
    () => normalizeRows(selectsData.brands),
    [selectsData.brands]
  );

  const ubicationRows = useMemo(
    () => normalizeRows(selectsData.ubication),
    [selectsData.ubication]
  );

  const currentOptions = useMemo(() => {
    const raw = usesModelWorkspace
      ? modelRows
      : selectsData[activeDef.dataKey] || [];
    return normalizeRows(raw);
  }, [activeDef.dataKey, modelRows, selectsData, usesModelWorkspace]);

  const selectedRow = useMemo(() => {
    if (selectedCatalogItemId == null || selectedCatalogItemId === "") return null;
    return (
      currentOptions.find(
        (item) => Number(item.value) === Number(selectedCatalogItemId)
      ) || null
    );
  }, [currentOptions, selectedCatalogItemId]);

  const selectedId = selectedRow?.value;

  const loadAllSelects = useCallback(async () => {
    try {
      const [biomedicalResponse, baseResponse] = await Promise.all([
        getSelectsBiomedical(),
        getCallSelectsBiomedicalEquipment()
      ]);

      const data = biomedicalResponse?.data || {};
      const baseData = baseResponse?.data || {};

      setSelectsData({
        ubication: data?.ubication || [],
        state: data?.state || [],
        adverseEvents: data?.adverseEvents || [],
        adverseEventTypes: data?.adverseEventTypes || [],
        adverseEventGravities: data?.adverseEventGravities || [],
        brands: data?.brands || [],
        importers: baseData?.importers || [],
        producers: baseData?.producers || [],
        riskClassifications: baseData?.riskClassifications || []
      });
    } catch (error) {
      pushToast(
        "error",
        "Catálogos biomédicos",
        "No se pudieron cargar los catálogos de administración biomédica."
      );
    }
  }, [pushToast]);

  const loadModelRows = useCallback(
    (brandId, nextSelectedId = null) => {
      const numericBrandId =
        brandId != null && brandId !== "" ? Number(brandId) : NaN;

      if (!Number.isFinite(numericBrandId) || numericBrandId <= 0) {
        setModelRows([]);
        setSelectedCatalogItemId(null);
        return;
      }

      callApiAsync(
        () => getBiomedicalEquipmentModels(numericBrandId),
        (data) => {
          const rows = normalizeRows(data || []);
          setModelRows(rows);
          if (nextSelectedId != null && nextSelectedId !== "") {
            setSelectedCatalogItemId(Number(nextSelectedId));
          }
        } 
      );
    },
    []
  );

  useEffect(() => {
    loadAllSelects();
  }, [loadAllSelects]);

  useEffect(() => {
    if (selectedCatalogItemId == null || selectedCatalogItemId === "") return;
    const exists = currentOptions.some(
      (item) => Number(item.value) === Number(selectedCatalogItemId)
    );
    if (!exists) setSelectedCatalogItemId(null);
  }, [currentOptions, selectedCatalogItemId]);

  useEffect(() => {
    if (!usesModelWorkspace) {
      setModelRows([]);
      setModelSummary(null);
      return;
    }

    if (selectedBrandId != null && selectedBrandId !== "") {
      loadModelRows(selectedBrandId);
    } else {
      setModelRows([]);
      setSelectedCatalogItemId(null);
    }
  }, [loadModelRows, selectedBrandId, usesModelWorkspace]);

  useEffect(() => {
    if (
      !usesModelWorkspace ||
      selectedId == null ||
      selectedId === "" ||
      !adminUserId
    ) {
      setModelSummary(null);
      return;
    }

    callApiAsync(
      () => getBiomedicalEquipmentModelSummary(selectedId, adminUserId),
      (data) => {
        setModelSummary(data || null);
      }
    );
  }, [adminUserId, selectedId, pushToast, usesModelWorkspace]);

  const resetCatalogWorkspace = useCallback(() => {
    setSelectedCatalogItemId(null);
    setSelectedBrandId(null);
    setModelRows([]);
    setModelSummary(null);
    setModelTab("catalog");
    setReassignNewBrandId(null);
    setOpenAddUbication(false);
    setOpenEditUbication(false);
    setOpenDeleteUbication(false);
    setOpenAddModel(false);
    setOpenEditModel(false);
    setOpenDeleteModel(false);
    setCatalogModalMode(null);
    setOpenDeleteCatalogItem(false);
  }, []);

  const handleCatalogCreate = useCallback(() => {
    const uid = adminUserId != null ? Number(adminUserId) : NaN;
    if (!Number.isFinite(uid) || uid <= 0) {
      pushToast(
        "error",
        "Sesión",
        "No se pudo obtener su usuario. Vuelva a iniciar sesión e intente de nuevo."
      );
      return;
    }
    if (activeCatalogId === "model") {
      setOpenAddModel(true);
      return;
    }
    if (isSimpleCatalog) {
      setCatalogModalMode("create");
      return;
    }
    setOpenAddUbication(true);
  }, [activeCatalogId, adminUserId, isSimpleCatalog, pushToast]);

  const handleCatalogEdit = useCallback(() => {
    if (selectedId == null || selectedId === "") {
      pushToast(
        "warn",
        "Selección requerida",
        activeCatalogId === "model"
          ? "Seleccione un modelo en el listado para editarlo."
          : `Seleccione ${activeSimpleCatalogMeta?.labelArticle || "un elemento del catálogo"} en el listado para editarlo.`
      );
      return;
    }

    if (activeCatalogId === "model") {
      setOpenEditModel(true);
      return;
    }
    if (isSimpleCatalog) {
      setCatalogModalMode("edit");
      return;
    }
    setOpenEditUbication(true);
  }, [activeCatalogId, activeSimpleCatalogMeta?.labelArticle, isSimpleCatalog, pushToast, selectedId]);

  const handleCatalogDelete = useCallback(() => {
    if (selectedId == null || selectedId === "") {
      pushToast(
        "warn",
        "Selección requerida",
        activeCatalogId === "model"
          ? "Seleccione un modelo en el listado para eliminarlo."
          : `Seleccione ${activeSimpleCatalogMeta?.labelArticle || "un elemento del catálogo"} en el listado para eliminarlo.`
      );
      return;
    }

    const uid = adminUserId != null ? Number(adminUserId) : NaN;
    if (!Number.isFinite(uid) || uid <= 0) {
      pushToast(
        "error",
        "Sesión",
        "No se pudo obtener su usuario. Vuelva a iniciar sesión e intente de nuevo."
      );
      return;
    }

    if (activeCatalogId === "model") {
      setOpenDeleteModel(true);
      return;
    }
    if (isSimpleCatalog) {
      setOpenDeleteCatalogItem(true);
      return;
    }
    setOpenDeleteUbication(true);
  }, [
    activeCatalogId,
    activeSimpleCatalogMeta?.labelArticle,
    adminUserId,
    isSimpleCatalog,
    pushToast,
    selectedId
  ]);

  const handleReassignBrand = useCallback(() => {
    if (selectedId == null || selectedId === "") {
      pushToast(
        "warn",
        "Selección requerida",
        "Seleccione primero un modelo para cambiarle la marca."
      );
      return;
    }

    const newBrand = Number(reassignNewBrandId);
    if (!Number.isFinite(newBrand) || newBrand <= 0) {
      pushToast(
        "warn",
        "Nueva marca requerida",
        "Seleccione la nueva marca que tendrá el modelo."
      );
      return;
    }

    if (Number(selectedRow?.brandId) === newBrand) {
      pushToast(
        "warn",
        "Marca sin cambios",
        "La nueva marca no puede ser igual a la actual."
      );
      return;
    }

    setReassignLoading(true);
    callActionApiAsync(
      () =>
        patchReassignBiomedicalEquipmentModelBrand({
          id: selectedId,
          newBrandId: newBrand,
          userId: adminUserId
        }),
      (data) => {
        pushToast(
          "success",
          "Modelo actualizado",
          `La marca del modelo se actualizó correctamente. Equipos sincronizados: ${data?.updatedEquipment ?? 0
          }.`
        );
        setSelectedBrandId(newBrand);
        setReassignNewBrandId(null);
        setModelTab("catalog");
        loadAllSelects();
        loadModelRows(newBrand, selectedId);
      },
      (error) => {
        pushToast(
          "error",
          "Cambio de marca",
          typeof error === "string" && error
            ? error
            : "No se pudo cambiar la marca del modelo."
        );
      },
      setReassignLoading
    );
  }, [
    adminUserId,
    loadAllSelects,
    loadModelRows,
    pushToast,
    reassignNewBrandId,
    selectedId,
    selectedRow?.brandId
  ]);


  return (
    <div className="admin-catalog-root">
      <BreadCrumbComp personalized="Administración biomédica" />

      <h1 className="gm-header-title-grey mb-25">Administración biomédica</h1>

      <div className="admin-catalog-layout">
        <nav className="admin-catalog-sidebar" aria-label="Catálogos del módulo">
          <div className="admin-catalog-sidebar-section">
            <button
              type="button"
              className="admin-catalog-sidebar-toggle"
              onClick={() => setNavExpanded((value) => !value)}
              aria-expanded={navExpanded}
              aria-controls="admin-catalog-sidebar-nav"
            >
              <span className="admin-catalog-sidebar-toggle-label">
                INVENTARIO DE EQUIPOS BIOMÉDICOS
              </span>
              <FaChevronDown
                className={`admin-catalog-sidebar-chevron ${navExpanded ? "is-open" : ""
                  }`}
                aria-hidden
              />
            </button>

            {navExpanded && (
              <div className="admin-catalog-sidebar-nav mb-10" id="admin-catalog-sidebar-nav">
                {CATALOG_DEFS.map((def) => (
                  <button
                    key={def.id}
                    type="button"
                    className={`admin-catalog-sidebar-link ${activeSectionId === "inventory" && activeCatalogId === def.id
                        ? "is-active"
                        : ""
                      }`}
                    onClick={() => {
                      resetCatalogWorkspace();
                      setActiveSectionId("inventory");
                      setActiveCatalogId(def.id);
                    }}
                  >
                    {def.shortLabel}
                  </button>
                ))}
              </div>
            )}
          </div>

          {SECTION_GROUPS.map((group) => (
            <div key={group.parentLabel} className="admin-catalog-sidebar-section">
              <p className="admin-catalog-sidebar-heading">{group.parentLabel}</p>
              <div className="admin-catalog-sidebar-nav mb-10">
                {(group.children || []).map((section) => (
                  <button
                    key={section.id}
                    type="button"
                    className={`admin-catalog-sidebar-link ${activeSectionId === section.id ? "is-active" : ""
                      }`}
                    onClick={() => {
                      resetCatalogWorkspace();
                      setActiveSectionId(section.id);
                      setActiveCatalogId("model");
                    }}
                  >
                    {section.shortLabel}
                  </button>
                ))}
              </div>
            </div>
          ))}

        </nav>

        <section className="admin-catalog-content">
          <p className="admin-catalog-description">{contentDescription}</p>

          {usesModelWorkspace ? (
            <>
              {activeSectionId === "inventory" && activeCatalogId === "model" && (
                <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
                  <Tabs
                    value={modelTab}
                    onChange={(_, value) => setModelTab(value)}
                    aria-label="Pestañas de administración de modelos"
                  >
                    <Tab value="catalog" label="Modelos" />
                    <Tab value="reassign" label="Cambiar marca del modelo" />
                  </Tabs>
                </Box>
              )}

              <div className="admin-catalog-dropdown-wrap">
                <p className="create-label">Marca:</p>
                <Dropdown
                  value={selectedBrandId}
                  onChange={(e) => {
                    setSelectedBrandId(
                      e.value != null && e.value !== "" ? Number(e.value) : null
                    );
                    setSelectedCatalogItemId(null);
                    setModelSummary(null);
                  }}
                  options={brandRows}
                  optionLabel="name"
                  optionValue="value"
                  placeholder="Seleccione una marca…"
                  filter
                  filterBy="name"
                  showClear
                  className="admin-catalog-dropdown w-complete"
                />
              </div>

              <div className="admin-catalog-dropdown-wrap">
                <Dropdown
                  value={selectedCatalogItemId}
                  onChange={(e) =>
                    setSelectedCatalogItemId(
                      e.value != null && e.value !== "" ? Number(e.value) : null
                    )
                  }
                  options={currentOptions}
                  optionLabel="name"
                  optionValue="value"
                  placeholder={
                    selectedBrandId
                      ? "Seleccione o busque en el catálogo…"
                      : "Seleccione primero una marca…"
                  }
                  filter
                  filterBy="name"
                  filterPlaceholder="Buscar…"
                  showClear
                  disabled={!selectedBrandId}
                  className="admin-catalog-dropdown w-complete"
                  emptyMessage="Sin registros en este catálogo"
                  virtualScrollerOptions={
                    currentOptions.length > 80 ? { itemSize: 38 } : undefined
                  }
                />
              </div>

              {activeSectionId === "lifeSheet" ? (
                <ModelResumeTab
                  modelRow={selectedRow}
                  userId={adminUserId}
                  isCatalogAdmin={isCatalogAdmin}
                  pushToast={pushToast}
                  equipmentCount={modelSummary?.equipmentCount ?? 0}
                />
              ) : activeSectionId === "lifeSheetFeatures" ? (
                <ModelTechnicalFeaturesTab
                  modelRow={selectedRow}
                  userId={adminUserId}
                  isCatalogAdmin={isCatalogAdmin}
                  pushToast={pushToast}
                  equipmentCount={modelSummary?.equipmentCount ?? 0}
                />
              ) : activeSectionId === "lifeSheetAccessories" ? (
                <ModelAccessoriesTab
                  modelRow={selectedRow}
                  userId={adminUserId}
                  isCatalogAdmin={isCatalogAdmin}
                  pushToast={pushToast}
                />
              ) : activeSectionId === "inspection" ? (
                <ModelInspectionProtocolTab
                  modelRow={selectedRow}
                  userId={adminUserId}
                  isCatalogAdmin={isCatalogAdmin}
                  pushToast={pushToast}
                />
              ) : activeCatalogId === "adverseEventsTemplate" ? (
                <ModelAdverseEventsTab
                  modelRow={selectedRow}
                  userId={adminUserId}
                  isCatalogAdmin={isCatalogAdmin}
                  pushToast={pushToast}
                  typeEventOptions={normalizeRows(selectsData.adverseEventTypes)}
                  gravityOptions={normalizeRows(selectsData.adverseEventGravities)}
                />
              ) : modelTab === "catalog" ? (
                <>
                  {isCatalogAdmin && (
                    <CatalogCrudToolbar
                      labels={activeDef.actionLabels}
                      onCreate={handleCatalogCreate}
                      onEdit={handleCatalogEdit}
                      onDelete={handleCatalogDelete}
                    />
                  )}
                </>
              ) : (
                <div className="admin-catalog-detail-card">
                  <div className="HContainer j-between">
                    <div className="mr-20">

                      <p className="admin-catalog-detail-label">Modelo actual</p>
                      <p className="admin-catalog-detail-value">
                        {selectedRow?.name || "Seleccione una marca y un modelo"}
                      </p>
                    </div>

                    <div>
                      <p className="admin-catalog-detail-label">Marca actual</p>
                      <p className="admin-catalog-detail-value">
                        {selectedRow?.brandName || modelSummary?.brandName || "—"}
                      </p>
                    </div>
                  </div>
                  <div className="admin-catalog-dropdown-wrap" style={{ marginBottom: 0 }}>
                    <p className="create-label">Nueva marca:</p>
                    <Dropdown
                      value={reassignNewBrandId}
                      onChange={(e) =>
                        setReassignNewBrandId(
                          e.value != null && e.value !== "" ? Number(e.value) : null
                        )
                      }
                      options={brandRows}
                      optionLabel="name"
                      optionValue="value"
                      placeholder="Seleccione la nueva marca…"
                      filter
                      filterBy="name"
                      showClear
                      className="admin-catalog-dropdown w-complete"
                    />
                  </div>
                  <div className="HContainer mt-20">
                    <LaddaButton
                      variant="contained"
                      onClick={handleReassignBrand}
                      disabled={reassignLoading}
                    >
                      Aplicar cambio de marca
                    </LaddaButton>
                  </div>
                </div>
              )}
            </>
          ) : (
            <>
              <div className="admin-catalog-dropdown-wrap">
                <Dropdown
                  value={selectedCatalogItemId}
                  onChange={(e) =>
                    setSelectedCatalogItemId(
                      e.value != null && e.value !== "" ? Number(e.value) : null
                    )
                  }
                  options={currentOptions}
                  optionLabel="name"
                  optionValue="value"
                  placeholder="Seleccione o busque en el catálogo…"
                  filter
                  filterBy="name"
                  filterPlaceholder="Buscar…"
                  showClear
                  className="admin-catalog-dropdown w-complete"
                  emptyMessage="Sin registros en este catálogo"
                  virtualScrollerOptions={
                    currentOptions.length > 80 ? { itemSize: 38 } : undefined
                  }
                />
              </div>

              {isCatalogAdmin && (
                <CatalogCrudToolbar
                  labels={activeDef.actionLabels}
                  onCreate={handleCatalogCreate}
                  onEdit={handleCatalogEdit}
                  onDelete={handleCatalogDelete}
                />
              )}
            </>
          )}

          {!isCatalogAdmin && (
            <p className="admin-catalog-readonly-note">
              Solo puede consultar catálogos. Para crear o modificar registros
              necesita el rol de administrador de catálogos biomédicos.
            </p>
          )}
        </section>
      </div>

      <ToastNotification
        showToast={showToast}
        setShowToast={setShowToast}
        severity={toastConfig.severity}
        summary={toastConfig.summary}
        detail={toastConfig.detail}
      />

      <Grid container className="mt-15">
        <Grid item xs={12}>
          <AddUbicationModal
            open={openAddUbication}
            close={() => setOpenAddUbication(false)}
            getSelectsBiomedicalData={loadAllSelects}
            userId={adminUserId}
          />

          <AddModelModal
            open={openAddModel}
            close={() => setOpenAddModel(false)}
            brands={brandRows}
            userId={adminUserId}
            onSaved={() => {
              loadAllSelects();
              if (selectedBrandId) {
                loadModelRows(selectedBrandId);
              }
              setOpenAddModel(false);
            }}
          />

          <EditLocationModal
            open={openEditUbication}
            close={() => setOpenEditUbication(false)}
            locationRow={selectedRow}
            onSaved={() => {
              loadAllSelects();
              setOpenEditUbication(false);
            }}
            userId={adminUserId}
          />

          <EditModelModal
            open={openEditModel}
            close={() => setOpenEditModel(false)}
            modelRow={selectedRow}
            onSaved={() => {
              loadAllSelects();
              if (selectedBrandId) {
                loadModelRows(selectedBrandId, selectedId);
              }
              setOpenEditModel(false);
            }}
            userId={adminUserId}
          />

          <DeleteLocationModal
            open={openDeleteUbication}
            close={() => setOpenDeleteUbication(false)}
            locationRow={selectedRow}
            allRows={ubicationRows}
            userId={adminUserId}
            onDone={() => {
              loadAllSelects();
              setSelectedCatalogItemId(null);
              setOpenDeleteUbication(false);
            }}
          />

          <DeleteModelModal
            open={openDeleteModel}
            close={() => setOpenDeleteModel(false)}
            modelRow={selectedRow}
            userId={adminUserId}
            onDone={() => {
              loadAllSelects();
              if (selectedBrandId) {
                loadModelRows(selectedBrandId);
              }
              setSelectedCatalogItemId(null);
              setModelSummary(null);
              setOpenDeleteModel(false);
            }}
          />

          {activeSimpleCatalogMeta && (
            <CatalogItemModal
              open={catalogModalMode === "create" || catalogModalMode === "edit"}
              close={() => setCatalogModalMode(null)}
              mode={catalogModalMode}
              itemRow={selectedRow}
              userId={adminUserId}
              catalogDef={activeSimpleCatalogMeta}
              onSaved={() => {
                loadAllSelects();
                setCatalogModalMode(null);
              }}
            />
          )}

          {activeSimpleCatalogMeta && (
            <DeleteCatalogItemModal
              open={openDeleteCatalogItem}
              close={() => setOpenDeleteCatalogItem(false)}
              itemRow={selectedRow}
              allRows={currentOptions}
              userId={adminUserId}
              catalogDef={activeSimpleCatalogMeta}
              onDone={() => {
                loadAllSelects();
                setSelectedCatalogItemId(null);
                setOpenDeleteCatalogItem(false);
              }}
            />
          )}
        </Grid>
      </Grid>
    </div>
  );
};

export default BiomedicalAdminPage;
